export enum SupporterErrorTypeEnum {
  SupporterNotFound = 'SUPPORTER_NOT_FOUND',
  PaymentMethodsEmpty = 'PAYMENT_METHODS_EMPTY',
  PaymentMethodNotFound = 'PAYMENT_METHOD_NOT_FOUND',
  PaymentMethodHasCommitments = 'PAYMENT_METHOD_HAS_COMMITMENTS',
  PaymentMethodDelete = 'PAYMENT_METHOD_DELETE',
  PaymentMethodCreate = 'PAYMENT_METHOD_CREATE',
  PaymentMethodAlreadyExists = 'PAYMENT_METHOD_ALREADY_EXISTS',
  PaymentMethodUpdate = 'PAYMENT_METHOD_UPDATE',
  PaymentMethodTokenUpdateNotAllowed = 'PAYMENT_METHOD_TOKEN_UPDATE_NOT_ALLOWED',
  CommitmentPaymentPlan = 'COMMITMENT_PAYMENT_PLAN',
  AssignPaymentMethodToCommitment = 'ASSIGN_PAYMENT_METHOD_TO_COMMITMENT',
}
